// extracted by mini-css-extract-plugin
module.exports = {"isLoading":"LoadIndicator-isLoading_545dd820","loader":"LoadIndicator-loader_fab11734","icon":"LoadIndicator-icon_63c9209c","text":"LoadIndicator-text_85812b60"};